import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { clientLpStoreSelector } from '../clientLp.selector';
import { IClientLp } from '../clientLp.interface';

interface IClientLpAdapterSchemasSelectorProps {
  adapterName: IClientLp['adapter'] | undefined;
}

export const clientLpAdapterSchemasSelector = createCachedSelector(
  [
    path(clientLpStoreSelector).adapterSchemas(),
    prop<IClientLpAdapterSchemasSelectorProps>().adapterName(),
  ],
  (adapterSchemas, adapterName) => (adapterName ? adapterSchemas?.[adapterName] ?? undefined : undefined),
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: (_, props: IClientLpAdapterSchemasSelectorProps) => props.adapterName ?? '',
});
